const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="
  c-avatar
  `);
                if ((context.has(`size`) ? context.get(`size`) : null)) {
                    this.echo(`c-avatar--`);
                    this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`size`) ? context.get(`size`) : null), `html`, null, true]));
                }
                this.echo(`  `);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  `);
                this.traceableDisplayBlock(5, this.source)('content', context.clone(), blocks);
                this.echo(`</div>
`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`src`) ? context.get(`src`) : null)) {
                    this.echo(`<img src="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`src`) ? context.get(`src`) : null), `html`, null, true]));
                    this.echo(`"
        `);
                    if ((context.has(`srcset`) ? context.get(`srcset`) : null)) {
                        this.echo(`srcset="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (context.has(`srcset`) ? context.get(`srcset`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`        `);
                    this.echo(`        `);
                    if ((context.has(`sizes`) ? context.get(`sizes`) : null)) {
                        this.echo(`sizes="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`sizes`) ? context.get(`sizes`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`        `);
                    if (!!((context.has(`width`) ? context.get(`width`) : null) || (context.has(`height`) ? context.get(`height`) : null))) {
                        this.echo(`          width="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (((context.has(`width`))) ? (this.env.getFilter('default').traceableCallable(16, this.source)(...[(context.has(`width`) ? context.get(`width`) : null), (context.has(`height`) ? context.get(`height`) : null)])) : ((context.has(`height`) ? context.get(`height`) : null))), `html`, null, true]));
                        this.echo(`"
          height="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (((context.has(`height`))) ? (this.env.getFilter('default').traceableCallable(17, this.source)(...[(context.has(`height`) ? context.get(`height`) : null), (context.has(`width`) ? context.get(`width`) : null)])) : ((context.has(`width`) ? context.get(`width`) : null))), `html`, null, true]));
                        this.echo(`"
        `);
                    }
                    this.echo(`        alt="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, this.env.getFilter('trim').traceableCallable(19, this.source)(...[(((context.has(`alt`))) ? (this.env.getFilter('default').traceableCallable(19, this.source)(...[(context.has(`alt`) ? context.get(`alt`) : null), ``])) : (``))]), `html`, null, true]));
                    this.echo(`"
        loading="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(20, this.source)(...[this.env, (((context.has(`loading`))) ? (this.env.getFilter('default').traceableCallable(20, this.source)(...[(context.has(`loading`) ? context.get(`loading`) : null), `lazy`])) : (`lazy`)), `html`, null, true]));
                    this.echo(`">`);
                }
            }

            getTemplateName() {
                return `6e717218367333c7216ac0d9c676f58c2cc032d315a3783ca4ad1a2eefaca39a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6e717218367333c7216ac0d9c676f58c2cc032d315a3783ca4ad1a2eefaca39a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6e717218367333c7216ac0d9c676f58c2cc032d315a3783ca4ad1a2eefaca39a');

let template = env.loadTemplate('6e717218367333c7216ac0d9c676f58c2cc032d315a3783ca4ad1a2eefaca39a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/avatar/avatar.twig", args: context }
     );
     return rendered;;
};